import MenuLink from '@frontend/features/navigation/components/menu/MenuLink'
import MenuList from '@frontend/features/navigation/components/menu/MenuList'
import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { isMobileDevice } from '@frontend/libs/utils'
import { Image } from '@nextui-org/react'
import { Link } from 'react-router-dom'

function AsvMegaMenu() {
  const { settings } = useSiteConfiguration()

  if (!settings?.megaMenus.asv) {
    return <></>
  }

  const poster = settings.megaMenus.asv.poster
  const {
    categories,
    collections,
    galleries,
    newArrivals,
    onlineExclusives,
    specialPrice,
  } = settings.megaMenus.asv.menus

  return (
    <div className="mx-auto max-w-screen-2xl md:px-7 md:py-6">
      <div className="grid grid-cols-1 gap-14 md:flex">
        <div className="max-w-[315px] md:w-2/6">
          {poster && (
            <Link
              target={poster.link.target}
              title={poster.link.title}
              to={poster.link.url}
            >
              <Image
                alt={poster.title}
                classNames={{
                  img: 'opacity-100',
                }}
                disableSkeleton
                isLoading={false}
                loading="eager"
                src={isMobileDevice ? poster.src.mobile : poster.src.desktop}
              />
              <p className="m-0 mt-3 font-medium uppercase text-primary">
                {poster.title}
              </p>
            </Link>
          )}
        </div>
        <div className="md:w-1/6">
          <MenuLink link={newArrivals.link} title={newArrivals.title} />
        </div>
        {onlineExclusives && (
          <div className="md:w-1/6">
            <MenuList
              items={onlineExclusives.items}
              title={onlineExclusives.title}
            />
          </div>
        )}
        <div className="md:w-1/6">
          <MenuList items={collections.items} title={collections.title} />
        </div>
        <div className="md:w-1/6">
          <MenuList items={categories.items} title={categories.title} />
        </div>
        <div className="md:w-1/6">
          <MenuList items={galleries.items} title={galleries.title} />
          {specialPrice && (
            <MenuLink
              className="mt-6 block text-base font-medium uppercase italic text-red-600"
              link={specialPrice.link}
              title={specialPrice.title}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default AsvMegaMenu
